<div>
  <mwe-button
    size="md"
    category="primary"
    [isIconBtn]="true"
    class="btn-bubble"
    (clicked)="isCollapsed.set(!this.isCollapsed())"
    [attr.data-test]="dataTest()"
  >
    <i class="fas fa-angle-up" [ngClass]="{ rotate: isCollapsed() }"></i>
  </mwe-button>
</div>
